module.exports = __webpack_public_path__ + "components/page-header/static/snow-forecast__logo--white-59681af204a417489d730d4379757532.svg";